import { AuthState } from 'models/IAuth';
import { GlobalActionTypes, GlobalActions } from './types';


interface GlobalState extends AuthState {
  appLoaded: boolean;
  error: string | null;
  isLoading: boolean;
  message: string | null;
  mapReady: boolean;
}

const initialState: GlobalState = {
  appLoaded: false,
  error: null,
  isAuthenticated: false,
  isLoading: false,
  mapReady: false,
  me: null,
  message: null,
  token: localStorage.getItem('token'),
};
export default function (state = initialState, action: GlobalActions): GlobalState {
  switch (action.type) {
    case GlobalActionTypes.SUCCESS_LOAD:
      return {
        ...state,
        isLoading: false,
        error: null,
        appLoaded: true,
        ...action.payload
      };
    case GlobalActionTypes.LOADING:
      return {
        ...state,
        isLoading: true
      };
    case GlobalActionTypes.MESSAGE_FAIL:
      return {
        ...state,
        isLoading: false,
        appLoaded: true,
        ...action.payload,
      };
    case GlobalActionTypes.CLEAR_ERRORS:
      return {
        ...state,
        error: null,
        message: null,
      };
    case GlobalActionTypes.MAP_READY:
      return {
        ...state,
        mapReady: true,
      };
    default:
      return state;
  }
}
